import * as React from "react";

function SvgLow(props) {
  return <svg viewBox="0 0 7 6" fill="none" width="1em" height="1em" {...props}><g clipPath="url(#low_svg__clip0_13003_2492)"><rect y={-0.001} width={6.003} height={6.002} rx={3.001} fill="#FF4D4F" /></g><defs><clipPath id="low_svg__clip0_13003_2492" /></defs></svg>;
}

export default SvgLow;